module.exports = __webpack_public_path__ + "media/images/criteo_logo-4c17d188898674a02d4130e9e83c7d23.png";